module.exports = __webpack_public_path__ + "static/media/wx-moment.d048f2bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wx-moment.png
// module id = 169
// module chunks = 6